import React, { FC } from "react";

import { PrintSettingsContainer } from "../styled";
import { TitleSetting } from "./TitleSetting";
import { GridSetting } from "./GridSetting";
import { LegendSetting } from "./LegendSetting/LegendSetting";
import { ScaleSetting } from "./ScaleSetting";

export const PrintSettings: FC = () => (
  <PrintSettingsContainer>
    <TitleSetting />
    <ScaleSetting />
    <GridSetting />
    <LegendSetting />
  </PrintSettingsContainer>
);
